export const doesTickerExist = (ticker: string, watchlist: string[]): boolean => {
    const trimmedTicker = ticker.trim();
    return watchlist.some(existingTicker => existingTicker.toLowerCase() === trimmedTicker.toLowerCase());
};
